export default __webpack_public_path__ + "static/media/num-1.5e7d417f.svg";